import React from 'react'
import "./Footer.css"
import { FiFacebook } from "react-icons/fi";
import { MdOutlineMail } from "react-icons/md";
import { FaInstagram } from "react-icons/fa";
import { IconContext } from "react-icons";
import { IoLocationOutline } from "react-icons/io5";
import { BsTelephone } from "react-icons/bs";
import { FaHeart } from "react-icons/fa";
import { Helmet } from 'react-helmet';


const Footer = () => {

  const buttoncolor=()=>{
    document.getElementById('footerformbutton').style.cssText='backround-color:red';
  }
  setTimeout(()=>{
    document.body.classList.add('bg-white');
  },100)
  return (
    <>

<Helmet>
        <title>Real Estate Investments | GridRadhika</title>
        <meta name="description" content="Find the best real estate investment opportunities with GridRadhika. Our properties offer great views and affordable prices." />
        <meta name="keywords" content="real estate, property investment, affordable real estate, mountain views, GridRadhika, plots, property near me, good property, flats near me, flat for rent in noida, flat for rent in gurugram, property in Uttarakhand" />
        <meta property="og:title" content="Real Estate Investments | GridRadhika" />
        <meta property="og:description" content="Looking for a smart real estate investment? GridRadhika offers premium properties at competitive prices." />
        <meta property="og:url" content="https://gridradhika.com" />
        <meta property="og:type" content="website" />
      </Helmet>



      <div className='bgcolor'>
          <div className='footermain'>
            <div className='footerup'>

              <div className='footer1'>
                <div className='footerlogo'>
                  <img src="/assets/Grid.png" alt="Grid Radhika Real Estate Logo"  />
                </div>
                <div className='footertext'>
                  <p>Looking for an investment in real estate? We will help you out with the best places and within best budget!</p>
                </div>
                <div className='footericons'>
                <IconContext.Provider value={{ className: "footerimany" }}>
                  {/* Facebook link */}
                  <a href="https://www.facebook.com/gridradhika" target="_blank" rel="noopener noreferrer" aria-label="Visit GridRadhika on Facebook">
                    <div className='box'><FiFacebook /></div>
                  </a>
                  {/* Instagram link */}
                  <a href="https://www.instagram.com/gridradhika" target="_blank" rel="noopener noreferrer" aria-label="Visit GridRadhika on Instagram">
                    <div className='box'><FaInstagram /></div>
                  </a>
  <a href="mailto:gridradhika@gmail.com" aria-label="Email GridRadhika">
  <div className='box'><MdOutlineMail /></div>
  </a>

                </IconContext.Provider>
                </div>
              </div>

              <div className='footer2'>
                <div className='footerheadings'>
                  <h2>Office</h2>
                </div>
           
                <div className='footersubheadings'>
                  <IconContext.Provider value={{ className: "footeriless" }}>
                    <IoLocationOutline />
                  </IconContext.Provider>
                  <p>B 1 Swarna Jayanti Puram<br />
                    Govind Puram,<br />
                    Ghaziabad, Uttar Pradesh <br /></p>
                </div>

                <div className='footersubheadings'>
                  <IconContext.Provider value={{ className: "footerimail" }} aria-label="Email GridRadhika">
                    <MdOutlineMail />
                  </IconContext.Provider>
                  <p>gridradhika@gmail.com</p>
                </div>

                <div className='footersubheadings'>
                  <IconContext.Provider value={{ className: "footerimail" }} aria-label="Call GridRadhika">
                    <BsTelephone />
                  </IconContext.Provider>
                  <p>7289864030</p>
                </div>




              </div>
              


            </div>
          
          </div>
        </div>
        <div className='line'></div>
            <div className='footerdown'>
              <p>
            &copy;  2024 GridRadhika. Design & Develop with  <IconContext.Provider value={{ className: "footeriheart" }}>
            <FaHeart />
                    </IconContext.Provider> by 
                    <a className="anmol" href="https://retronoob.netlify.app" aria-label="Visit Anmol's portfolio">
                    Anmol Chaudhary.
                    </a>
                
              </p>
            </div>

    </>
  )
}

export default Footer